App.directive('userFormDirective', function() {
    return {
        restrict: 'E',
        scope: {
            user: '=user'
        },
        templateUrl: 'components/users/partials/formView.html'
    };
});